"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isRequestClearShoppingCacheEvent = exports.RequestClearShoppingCacheEvent = exports.Name = void 0;
const Name = exports.Name = 'request-clear-shopping-cache';
const RequestClearShoppingCacheEvent = exports.RequestClearShoppingCacheEvent = Name;
const isRequestClearShoppingCacheEvent = event => event instanceof CustomEvent && event.type === Name;
exports.isRequestClearShoppingCacheEvent = isRequestClearShoppingCacheEvent;
